import clsx from 'clsx';
import { ReactNode } from 'react';

interface Props extends BaseProps {
  border?: 'none' | 'block' | 'inline' | 'left' | 'right' | 'top' | 'bottom';
  children: ReactNode;
  flex?: 'none' | 'row' | 'column';
  gap?: 'none' | 'default' | 'md' | 'lg' | 'xl';
  noWrap?: boolean;
  padding?: PaddingVariant;
}

export const CardContent = (props: Props) => {
  const {
    border = 'none',
    children,
    className = '',
    flex = 'column',
    gap = 'default',
    noWrap = false,
    padding = 'md',
    ...rest
  } = props;
  const classes = useStyles();

  return (
    <div
      className={clsx(
        className,
        classes.border[border],
        classes.default,
        classes.flex[flex],
        classes.gap[gap],
        classes.padding[padding],
        { [classes.noWrap]: noWrap }
      )}
      {...rest}
    >
      {children}
    </div>
  );
};

const useStyles = () => {
  const borderStyle = 'border-border-light dark:border-border-dark';
  return {
    border: {
      none: 'border-0',
      block: `border-t border-b ${borderStyle}`,
      inline: `border-l border-r ${borderStyle}`,
      left: `border-l ${borderStyle}`,
      right: `border-r ${borderStyle}`,
      top: ` border-t ${borderStyle}`,
      bottom: ` border-b ${borderStyle}`,
    },
    default: 'relative',
    flex: {
      none: 'flex-none',
      row: 'flex flex-row flex-wrap',
      column: 'flex flex-col flex-wrap',
    },
    gap: {
      none: 'gap-0',
      default: 'gap-2',
      md: 'gap-4',
      lg: 'gap-6',
      xl: 'gap-8',
    },
    noWrap: 'flex-nowrap',
    padding: {
      none: 'p-0',
      sm: 'p-2',
      md: 'p-4',
      lg: 'p-6',
    },
  };
};
